import React from 'react';
import { motion } from 'framer-motion';
import { Container, Row, Col } from 'react-bootstrap';
import './FooterNew.css';

const Footer = ({ navigateTo }) => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const socialLinks = [
    {
      icon: 'bi bi-linkedin',
      href: 'https://linkedin.com/company/dhrstructures',
      label: 'LinkedIn',
      color: '#0077B5'
    },
    {
      icon: 'bi bi-facebook',
      href: 'https://facebook.com/dhrstructures',
      label: 'Facebook',
      color: '#1877F2'
    },
    {
      icon: 'bi bi-instagram',
      href: 'https://instagram.com/dhrstructures',
      label: 'Instagram',
      color: '#E4405F'
    },
    {
      icon: 'bi bi-twitter',
      href: 'https://twitter.com/dhrstructures',
      label: 'Twitter',
      color: '#1DA1F2'
    }
  ];

  return (
    <footer className="footer-section">
      {/* Animated Background */}
      <div className="footer-background">
        <div className="animated-grid">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="grid-dot" style={{
              '--delay': `${Math.random() * 3}s`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`
            }}></div>
          ))}
        </div>
      </div>

      <Container>
        {/* Main Footer Content */}
        <div className="footer-content">
          <Row>
            {/* Logo et Description */}
            <Col lg={4} md={6} className="mb-4">
              <motion.div
                className="footer-brand"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="brand-logo">
                  <div className="logo-icon">
                    <img
                      src="/images/logo-dhr-nobackrgound.png"
                      alt="DHR Structures"
                      style={{ width: '75px', height: '75px', objectFit: 'contain' }}
                    />
                  </div>
                  <div className="brand-text">
                    <h3>DHR Structures</h3>
                    <p>Ingéniosité - Maîtrise – Performance</p>
                  </div>
                </div>

                <p className="brand-description">
                  Votre partenaire de confiance en ingénierie structurale.
                  Nous concevons l'avenir avec une approche alliant expertise,
                  innovation et durabilité au cœur de chaque projet.
                </p>

                {/* Certifications */}
                <div className="certifications">
                  <div className="cert-label">
                    <i className="bi bi-patch-check-fill"></i>
                    <span>Conformité aux Normes Canadiennes</span>
                  </div>
                  <div className="cert-item">
                    <i className="bi bi-award"></i>
                    <span>Ordre des ingénieurs du Québec (OIQ)</span>
                  </div>
                  <div className="cert-item">
                    <i className="bi bi-building"></i>
                    <span>Code national du bâtiment – Canada (CNB)</span>
                  </div>
                  <div className="cert-item">
                    <i className="bi bi-shield-check"></i>
                    <span>Association canadienne de normalisation (CSA Group)</span>
                  </div>
                </div>
              </motion.div>
            </Col>

            {/* Notre Entreprise */}
            <Col lg={2} md={6} className="mb-4">
              <motion.div
                className="footer-section-block"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                <h4 className="footer-col-title">Notre Entreprise</h4>
                <ul className="footer-links">
                  <li>
                    <button
                      onClick={() => navigateTo('home')}
                      className="footer-link"
                    >
                      <i className="bi bi-house"></i>
                      Accueil
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigateTo('contact')}
                      className="footer-link"
                    >
                      <i className="bi bi-envelope"></i>
                      Contact
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => scrollToSection('about')}
                      className="footer-link"
                    >
                      <i className="bi bi-info-circle"></i>
                      À Propos
                    </button>
                  </li>

                </ul>
              </motion.div>
            </Col>

            {/* Nos Projets */}
            <Col lg={2} md={6} className="mb-4">
              <motion.div
                className="footer-section-block"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <h4 className="footer-col-title">Navigation</h4>
                <ul className="footer-links">
                  <li>
                    <button
                      onClick={() => navigateTo('services')}
                      className="footer-link"
                    >
                      <i className="bi bi-gear"></i>
                      Services
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigateTo('projects')}
                      className="footer-link"
                    >
                      <i className="bi bi-folder"></i>
                      Projets
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => navigateTo('team')}
                      className="footer-link"
                    >
                      <i className="bi bi-people"></i>
                      Équipe
                    </button>
                  </li>

                </ul>
              </motion.div>
            </Col>

            {/* Contact */}
            <Col lg={4} md={6} className="mb-4">
              <motion.div
                className="footer-section-block"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <h4 className="footer-col-title">Contact</h4>

                <div className="contact-info">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="bi bi-geo-alt-fill"></i>
                    </div>
                    <div className="contact-details">
                      <strong>Adresse</strong>
                      <p>617-350 boul. de la Côte-Vertu<br />Montréal (Québec) H4N 1E2 Canada</p>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="bi bi-telephone-fill"></i>
                    </div>
                    <div className="contact-details">
                      <strong>Téléphone</strong>
                      <p>+1 438 994 6843</p>
                    </div>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon">
                      <i className="bi bi-envelope-fill"></i>
                    </div>
                    <div className="contact-details">
                      <strong>Email</strong>
                      <p>info@dhrstructures.ca</p>
                    </div>
                  </div>
                </div>

                {/* Réseaux Sociaux */}
                <div className="social-section">
                  <h5 className="social-title">Suivez-nous</h5>
                  <div className="social-links">
                    {socialLinks.map((social, index) => (
                      <motion.a
                        key={social.label}
                        href={social.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        whileHover={{
                          scale: 1.1,
                          backgroundColor: social.color,
                          rotate: 5
                        }}
                        whileTap={{ scale: 0.95 }}
                        style={{ '--hover-color': social.color }}
                      >
                        <i className={social.icon}></i>
                      </motion.a>
                    ))}
                  </div>
                </div>
              </motion.div>
            </Col>
          </Row>
        </div>

        {/* Footer Bottom */}
        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <Row className="align-items-center">
            <Col lg={12} className="text-center">
              <p className="copyright">
                © {currentYear} DHR Structures. Tous droits réservés.
              </p>
            </Col>

          </Row>
        </motion.div>
      </Container>
    </footer>
  );
};

export default Footer;